import { generateClient } from 'aws-amplify/api';
import { updateLocation } from "../graphql/mutations";

const client = generateClient();

export default async ({
    id,
    name,
    phoneNumber,
    address,
    address1,
    city,
    province,
    postalCode,
    maxDailyHours,
    maxWeeklyHours,
    payPeriodStart,
    utcOffset,
    syncTasks,
    dailyTimeReportReceivers,
    supportURL,
    termsOfUseURL,
    privacyURL,
    mediaTargetFilesize,
    mediaCompression
}) => {
    try {
        const {
            data: { updateLocation: updatedLocation },
        } = await client.graphql({
            query: updateLocation,
            variables: {
                input: {
                    id,
                    name,
                    phoneNumber,
                    address,
                    address1,
                    city,
                    province,
                    postalCode,
                    maxDailyHours,
                    maxWeeklyHours,
                    utcOffset,
                    payPeriodStart,
                    syncTasks,
                    supportURL,
                    termsOfUseURL,
                    privacyURL,
                    mediaTargetFilesize,
                    mediaCompression,
                    dailyTimeReportReceivers: dailyTimeReportReceivers.map(({ email }) => ({ email }))
                },
            },
        });
        return updatedLocation;
    } catch (ex) {
        console.error("Failed to update daily report", ex);
    }
};
